<template>
    <div class="portlet light portlet-fit">
        <div class="portlet-title">
            <div class="caption">
                <i class="icon-compass font-red-sunglo"></i><span class="caption-subject font-red-sunglo uppercase bold">{{ method ==='put' ? 'Modifier' : 'Créer' }} votre activité</span>
            </div>
            <button class="btn btn-primary pull-right" @click="send()" style="z-index: 1000">Sauvegarder et quitter</button>
        </div>
        <div class="row">
            <form-wizard title="" subtitle="" color="#70a6b2" ref="wizard" back-button-text="Précédent" next-button-text="Suivant" finish-button-text="Terminer" @on-complete="validate()" @on-change="saveToLocalStorage()">
              <tab-content title="Catégories">
                <div class="portlet light">
                    <div class="ss-titre">
                        <span class="font-red-sunglo uppercase bold">Catégories</span>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <v-select type="text" name="season" title="Saison *" v-model="newActivity.seasons" :items="seasons"
                                      v-validate="'required'" data-vv-as="Saison" attributeValue="value" :multiple="true"></v-select>
                            <div v-show="ferrors.has('season')" class="alert alert-danger">{{ ferrors.first('season') }}</div>

                            <v-select type="text" name="experience" title="Type d'Experience *" v-model="newActivity.experience"
                                      v-validate="'required'" data-vv-as="Type d'Experience" :items="experiences" attributeValue="value"></v-select>
                            <div v-show="ferrors.has('experience')" class="alert alert-danger">{{ ferrors.first('experience') }}</div>
                        </div>
                        <div class="col-md-5 col-md-push-1">
                            <v-select type="text" name="type" title="Type d'activité *" v-model="newActivity.type"
                                      v-validate="'required'" data-vv-as="Type d'activité" :items="types" attributeValue="token"></v-select>
                            <div v-show="ferrors.has('type')" class="alert alert-danger">{{ ferrors.first('type') }}</div>

                            <v-select type="text" name="nature" title="Type d'Encadrement *" v-model="newActivity.nature"
                                      v-validate="'required'" data-vv-as="Type d'Encadrement" :items="natures" attributeValue="value"></v-select>
                            <div v-show="ferrors.has('nature')" class="alert alert-danger">{{ ferrors.first('nature') }}</div>
                        </div>
                    </div>
                </div>
            </tab-content>
            <tab-content title="Informations Générales">
                <div class="portlet light ">
                    <div class="ss-titre">
                        <span class="font-red-sunglo uppercase bold">Informations Générales</span>
                    </div>
                    <div class="row">
                        <v-input type="text" name="name" title="Titre de l'activité *" v-model="newActivity.name" v-validate="'required'" data-vv-as="Titre de l'activité"></v-input>
                        <div v-show="ferrors.has('name')" class="alert alert-danger">{{ ferrors.first('name') }}</div>
                        <v-input type="text" name="place" title="Lieu *" v-model="newActivity.place" v-validate="'required'" data-vv-as="Lieu"  placeholder="Ville, Département, Pays"></v-input>
                        <div v-show="ferrors.has('place')" class="alert alert-danger">{{ ferrors.first('place') }}</div>
                        <v-input type="number" name="price" title="Prix(HT) *" v-model="newActivity.price" v-validate.continues="'required|priceFormat'" data-vv-as="Prix" placeholder="Prix de vente sans devise. Exemple: 200" unit="€"></v-input>
                        <div v-show="ferrors.has('price')" class="alert alert-danger">{{ ferrors.first('price') }}</div>
                        <v-input type="number" name="duration" title="Durée (Jours) *" v-model="newActivity.duration_days" v-validate="'required|min_value:0'" data-vv-as="Durée (Jours)" placeholder="Durée totale"></v-input>
                        <div v-show="ferrors.has('duration')" class="alert alert-danger">{{ ferrors.first('duration') }}</div>
                        <v-input type="number" step="1" name="physical_level" title="Niveau Physique *" v-model="newActivity.physical_level" v-validate="{ required: true, between:[1,4] }" data-vv-as="Niveau Physique" placeholder="niveau de 1 à 4 (sportif occasionnel, régulier, confirmé, extrême)"></v-input>
                        <div v-show="ferrors.has('physical_level')" class="alert alert-danger">{{ ferrors.first('physical_level') }}</div>
                        <v-input type="number" name="technical_level" title="Niveau Technique *" v-model="newActivity.technical_level" v-validate="{ required: true, between:[1,4] }" data-vv-as="Niveau Technique" placeholder="niveau de 1 à 4 (initiation, débutant, intermédiaire, confirmé)"></v-input>
                        <div v-show="ferrors.has('technical_level')" class="alert alert-danger">{{ ferrors.first('technical_level') }}</div>

                        <v-input type="number" name="min_persons" title="Départ assuré a partir de *" v-model="newActivity.min_persons" v-validate="'required|maxIfExist:'+newActivity.max_persons" data-vv-as="Départ assuré a partir de " placeholder="nombre minimum de personnes. Exemple: 2"></v-input>
                        <div v-show="ferrors.has('min_persons')" class="alert alert-danger">{{ ferrors.first('min_persons') }}</div>

                        <v-input type="number" name="max_persons" title="Nombre maximum de personnes *" v-model="newActivity.max_persons" v-validate="'required|minIfExist:'+newActivity.min_persons" data-vv-as="Nombre maximum de personnes" placeholder="nombre maximum de personnes. Exemple: 15"></v-input>
                        <div v-show="ferrors.has('max_persons')" class="alert alert-danger">{{ ferrors.first('max_persons') }}</div>

                    </div>
                </div>
            </tab-content>
            <tab-content title="Proposition">
                <div class="portlet light ">
                    <div class="ss-titre">
                        <span class="font-red-sunglo uppercase bold">Proposition</span>
                    </div>
                    <div class="row">
                        <v-ckeditor name="resume" title="L'activité en résumé *" v-model="newActivity.resume" v-validate="'required'" data-vv-as="L'activité en résumé" ></v-ckeditor>
                        <div v-show="ferrors.has('resume')" class="alert alert-danger">{{ ferrors.first('resume') }}</div>
                    </div>

                    <div class="row">
                        <v-ckeditor name="strong_points" title="Points Forts *" v-model="newActivity.strong_points" v-validate="'required'" data-vv-as="Point Forts" ></v-ckeditor>
                        <div v-show="ferrors.has('strong_points')" class="alert alert-danger">{{ ferrors.first('strong_points') }}</div>
                    </div>

                    <div class="row">
                        <v-ckeditor name="detail" title="Programme détaillé *" v-model="newActivity.detail" v-validate="'required'" data-vv-as="Programme détaillé "></v-ckeditor>
                        <div v-show="ferrors.has('detail')" class="alert alert-danger">{{ ferrors.first('detail') }}</div>
                    </div>
                </div>
            </tab-content>
            <tab-content title="Organisation">
                <div class="portlet light ">
                    <div class="ss-titre">
                        <span class="font-red-sunglo uppercase bold">Organisation</span>
                    </div>
                    <div class="row">
                        <v-ckeditor name="include" title="Ce qui *est inclus* dans l'activité *" v-model="newActivity.include" v-validate="'required'" data-vv-as="Ce qui *est inclus* dans l'activité" :width="6"></v-ckeditor>
                        <div v-show="ferrors.has('include')" class="alert alert-danger">{{ ferrors.first('include') }}</div>
                        <v-ckeditor name="needed" title="Ce qui *n'est pas inclus* dans l'activité *" v-model="newActivity.needed" v-validate="'required'" data-vv-as="Ce qui *n'est pas inclus* dans l'activité" :width="6"></v-ckeditor>
                        <div v-show="ferrors.has('needed')" class="alert alert-danger">{{ ferrors.first('needed') }}</div>
                        <v-ckeditor name="prepare" title="Préparation - Fiche pratique *" v-model="newActivity.prepare" v-validate="'required'" data-vv-as='Préparation - Fiche pratique'></v-ckeditor>
                        <div v-show="ferrors.has('prepare')" class="alert alert-danger">{{ ferrors.first('prepare') }}</div>
                    </div>
                </div>
            </tab-content>
            <tab-content title="Terrain">
                <div class="portlet light ">
                    <div class="ss-titre">
                        <span class="font-red-sunglo uppercase bold">Terrain</span>
                    </div>
                    <div class="row">
                        <v-ckeditor name="appointment" title="Lieu de rendez-vous *" v-model="newActivity.appointment" v-validate="'required'" data-vv-as="Lieu de rendez-vous"></v-ckeditor>
                        <div v-show="ferrors.has('appointment')" class="alert alert-danger">{{ ferrors.first('appointment') }}</div>
                        <v-ckeditor name="route" title="Itinéraire prévu pendant l'activité *" v-model="newActivity.route" v-validate="'required'" data-vv-as="Itinéraire prévu pendant l'activité"></v-ckeditor>
                        <div v-show="ferrors.has('route')" class="alert alert-danger">{{ ferrors.first('route') }}</div>
                    </div>
                </div>
            </tab-content>
            <tab-content title="Inscription - Annulation - Assurance">
                <div class="portlet light">
                    <div class="ss-titre">
                        <span class="font-red-sunglo uppercase bold">Inscription - Annulation - Assurance</span>
                    </div>
                    <div class="row">
                        <v-ckeditor name="complement" title="Complément d'informations *" v-model="newActivity.complement" v-validate="'required'" data-vv-as="Complément d'informations" ></v-ckeditor>
                        <div v-show="ferrors.has('complement')" class="alert alert-danger">{{ ferrors.first('complement') }}</div>
                        <v-ckeditor name="plus" title="Inscription - Annulation - Assurance *" v-model="newActivity.plus" v-validate="'required'" data-vv-as="Inscription - Annulation - Assurance" ></v-ckeditor>
                        <div v-show="ferrors.has('plus')" class="alert alert-danger">{{ ferrors.first('plus') }}</div>
                    </div>
                </div>
            </tab-content>
            <tab-content title="Images">
                <div class="row">
                    <div class="col-md-6 text-center">
                        <h5>Ici votre photo de la vignette de l'activité</h5>
                        <v-image-upload
                            :oldImage="photo1"
                            name="photo1"
                            :ratio="16/9"
                            :key="imageKey"
                            @image="addNewImage">
                        </v-image-upload>
                        <div v-show="ferrors.has('photo1')" class="alert alert-danger">{{ ferrors.first('photo1') }}</div>
                    </div>
                    <div class="col-md-6 text-center">
                        <h5>Seconde photo</h5>
                        <v-image-upload
                        :oldImage="photo2"
                        name="photo2"
                        :ratio="16/9"
                        :key="imageKey"
                        @image="addNewImage"
                        :index="2">
                        </v-image-upload>
                        <div v-show="ferrors.has('photo2')" class="alert alert-danger">{{ ferrors.first('photo2') }}</div>
                    </div>
                </div>
            </tab-content>
            <div class="alert alert-danger"  v-show="customErrorMessage.error === true&&ferrors.all().length>0">
                <h3>{{customErrorMessage.message}}</h3><hr>
                <ul>
                    <li v-for="(error, errorIdx) in ferrors.all()" v-bind:key="errorIdx">{{ error }}</li>
                </ul>
            </div>
        </form-wizard>
    </div>
</div>
</template>

<script>
  export default {
    name: 'ActivityForm',
    props: {
      experiences: {
        type: Array,
        default: () => []
      },
      natures: {
        type: Array,
        default: () => []
      },
      types: {
        type: Array,
        default: () => []
      },
      seasons: {
        type: Array,
        default: () => []
      },
      activityId: {
        required: true,
        type: Number,
      }
    },
    data () {
      return {
        activity: {},
        newActivity: {},
        customErrorMessage:{
          error:false,
          message: '',
        },
        method: 'post',
        imageKey: 0,
        redirectPath: ''
      }
    },
    created() {
      globalEventBus.$on('uploaded', this.redirect)
      this.$validator.extend('maxIfExist', {
        //traduction du message d'erreur dans le fichier node_modules\vee-validate\dist\locale\fr_custom.js
        getMessage: () => 'The minimum number of people cannot be bigger than the maximum number of people.',
        validate: (value, { max }) => (max == null || max === '' || Number(value) <= Number(max))
      }, {
        paramNames: ['max']
      })
      this.$validator.extend('minIfExist',
        {
          getMessage: () => 'The maximum number of people cannot be smaller than the minimum number of people.',
          validate: (value, { min }) => (min == null || min === '' || Number(value) >= Number(min))
        }, {
          paramNames: ['min']
        })

      this.$validator.extend('priceFormat', {
          getMessage: () => 'The price is incorrect, it must be in the format 20 or 20.50 for example and greater than or equal to 0.',
          validate: (value) => {
            const regex = RegExp('^[0-9]{1,8}([\.,][0-9]{2,5})?$')
            return regex.test(value)
          }
        })
    },
    async mounted() {
      if(this.activityId !== 0) {
        const response = await axios.get(`/activities/${this.activityId}`)
        this.newActivity = this.activity = response.data
        this.newActivity.duration_days = this.newActivity.duration / 86400
        this.method = 'put'
      } else {
        this.newActivity = {}
        this.method = 'post'
      }

      if(this.storageAvailable('localStorage'))
      {
        if (localStorage.getItem('ActivityForm') && localStorage.getItem('ActivityForm') !== '{}')
        {
          const storedActivity = JSON.parse(localStorage.getItem('ActivityForm'))
          // Activity not in DB and localsave not in DB or in DB with matching ID
          if (this.activityId === 0 && !storedActivity.hasOwnProperty('id') || this.activityId == storedActivity.id
            && new Date(storedActivity.updated_at) >= new Date(this.newActivity.updated_at))
          {
            this.newActivity = storedActivity // Load activity from localStorage
          }
        }
        this.saveToLocalStorage()
      }

      this.imageKey++

      this.checkPersonal()

      this.$refs.wizard.activateAll()

      this.$validator.reset()
    },
    beforeDestroy() {
      globalEventBus.$off('uploaded')
    },
    computed: {
      path() {
        return this.method === 'put' ? `/activities/${this.newActivity.id}` : '/activities'
      },
      photo1() {
        return this.activity?.images?.find(img => img.name === 'photo1')
      },
      photo2() {
        return this.activity?.images?.find(img => img.name === 'photo2')
      },
      images() {
        return new vImageHelper()
      },
    },
    methods: {
      checkPersonal() {
        if (window.location.search !== '') {
          this.newActivity.is_personal = true
        }
      },
      validateActivityForm(e) {
        this.$validator.validateAll()
        if (this.ferrors.any() && this.ferrors.count() !== 12) //[quick fix]Cette ligne sera améliorée car peut devenir source d'erreur
        {
          this.customErrorMessage = {
            error: true,
            message: 'Vous avez encore des champs requis manquants. Veuillez cliquer sur "Sauvegarder et Quitter" si vous voulez sauvegarder votre travail.'
          }
        } else {
          this.send()
        }
      },
      validate() {
        this.$validator.validateAll().then(result => {
          if (result) {
            this.send()
          } else {
            let msg = this.ferrors.all().length > 1 ? 'Erreurs lors de la validation :' : 'Erreur lors de la validation :'
            this.customErrorMessage = {
              error: true,
              message: msg
            }
          }
        })
      },
      addNewImage(event) {
        this.images.add(event)
      },
      async send() {
        this.newActivity.duration = this.newActivity.duration_days * 86400
        const response = await axios[this.method](this.path, this.newActivity)
        if (response.status === 422) {
          this.$refs.wizard.activateTab(1)
        } else {
          this.$snotify.success('Votre activité a bien été sauvegardée')
          if (this.storageAvailable('localStorage')) {
            localStorage.removeItem('ActivityForm')
          }
          if (Object.keys(this.images['images']).length === 0) {
            window.location.href = response.data.redirect
          } else {
            this.sendImages(response.data)
          }
        }
      },
      sendImages(activity) {
        this.redirectPath = activity.redirect
        this.images.send(`/activities/${activity.activity.id}/image`)
      },
      redirect(event) {
        if (event.updated === true) {
          window.location.href = this.redirectPath
        }
      },
      saveToLocalStorage() {
        if (this.storageAvailable('localStorage')) {
          localStorage.setItem('ActivityForm', JSON.stringify(this.newActivity))
          return true
        }
        return false
      },
      storageAvailable(type) {
        const storage = window[type], x = '__storage_test__'

        try {
          storage.setItem(x, x)
          storage.removeItem(x)
          return true
        } catch (e) {
          return e instanceof DOMException && (
              // everything except Firefox
              e.code === 22 ||
              // Firefox
              e.code === 1014 ||
              // test name field too, because code might not be present
              // everything except Firefox
              e.name === 'QuotaExceededError' ||
              // Firefox
              e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
            // acknowledge QuotaExceededError only if there's something already stored
            storage.length !== 0
        }
      },
    },
}
</script>
